import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { FascicoloMap } from '../../../models/fascicolo-map';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { DocumentVersionUpdateFormComponent } from './documento-version-update-form.component';

declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;

@Component({
    selector: 'div [doc_version_update_modal]',
  templateUrl: 'document-version-update-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DocumentVersionUpdateModal {
  @Input() fascicolo;
  @Input() tipoPratica: string;
  @Output() onReturn: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('docVersionUpdateForm') documentVersionUpdateForm: DocumentVersionUpdateFormComponent;
  documento: DocumentoAllegato;

  constructor(private operationService: OperationsService, private helpers: HelpersService) {}

  initForm(documento, isSearchModule: boolean= false) {
     if (!isSearchModule) {
      this.documento = documento;
      this.documentVersionUpdateForm.buildForm(documento);
      openModal('docVersionUpdateModal');
    } else {
      if (isSearchModule) {
        this.getFascicoloFull(documento);
        this.tipoPratica = documento.praticaLight.tipoPratica.id;
        this.helpers.getDocumentoAllegato(documento.intestazione.campi.idDocumento).subscribe(response => this.initFormFromSearchModule(response.documento, this.fascicolo));
      }
    }
  }

  initFormFromSearchModule(documentoAllegato: DocumentoAllegato, fascicolo) {
      this.documento = documentoAllegato;
      this.documentVersionUpdateForm.buildForm(this.documento);
      openModal('docVersionUpdateModal');
  }

  // CREAZIONE RAPIDA
  initFormCreazioneRapida(documento, modalName: string) {
    this.documento = documento;
    this.documentVersionUpdateForm.buildForm(documento);
    openModal(modalName);
  }
  

  getFascicoloMap(fascicolo, pratica): FascicoloMap {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[fascicolo.tipoFascicolo.id];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
    return <FascicoloMap>getFascicoloMapSync(pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
  }

  getFascicoloFull(documento) {
      let fascicoloFull: FascicoloFull;
      let fascicoloMap: FascicoloMap = this.getFascicoloMap(documento.praticaLight.fascicoliLight[0], documento.praticaLight);
      let idFascicoloAssociato = documento.entitaAssociate[1];
      this.operationService.readFascicolo(fascicoloMap.pathView, idFascicoloAssociato).subscribe(response => this.fascicolo = response.fascicolo);
  }

  createForm(documento: DocumentoAllegato) {
    this.documentVersionUpdateForm.createForm(documento);
  }

  manageModal(sezione: string) {
    if (sezione) {
      closeModal('docVersionUpdateModal');
      this.onReturn.emit(sezione);
    }
  }
}
